import IconComponent from "@mdi/react";
import { FunctionComponent } from "react";

import { mdiContentCopy } from "@mdi/js";
import { Tooltip } from "antd";

import { ActionButton } from "./ActionButton";

interface CopyTableButtonProps {
  onCopy: () => void;
  isDisabled?: boolean;
}

export const CopyTableButton: FunctionComponent<CopyTableButtonProps> = ({
  onCopy,
  isDisabled
}) => {
  return (
    <Tooltip title="Copy Data Table" mouseEnterDelay={0.6}>
      <ActionButton
        data-testid="copy-chart-data-table-button"
        onClick={onCopy}
        disabled={isDisabled}>
        <IconComponent path={mdiContentCopy} size={1.2} />
      </ActionButton>
    </Tooltip>
  );
};
